<template>
    <v-row v-resize="onResize" align="center" justify="center">
      <template v-if="maintain">
        <div class="d-flex justify-center align-center">
          <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
        </div>
      </template>
      <template v-else>
        <template v-if="CheckAdmin">
            <v-content>
                <v-container>
                    <v-card style="border: 1px solid">
                        <v-toolbar
                                color="primary">
                            <v-card-title class="headline">
                                <span style="color:white">ตั้งค่า Competency</span>
                            </v-card-title>
                        </v-toolbar>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-container>
                                    <v-card>
                                        <v-text-field
                                                v-model="search"
                                                label="ค้นหา (คลิก)"
                                                dark
                                                flat
                                                solo-inverted
                                                hide-details
                                                clearable
                                                clear-icon="mdi-close-circle-outline"
                                        ></v-text-field>
                                        <v-treeview :activatable="true" :items="items" :search="search">
                                            <template v-slot:prepend="{ item, open }">
                                                <v-icon v-if="!item.file" color="blue lighten-2">
                                                    {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                                                </v-icon>
                                                <v-icon v-else>
                                                    {{ files[item.file] }}
                                                </v-icon>
                                            </template>
                                            <template v-slot:label="{ item, active }">
                                                <div v-if="isMobile" style="cursor: pointer" @click="ShowDetail(item)">
                                                <span style="font-size: 12px;color: black" v-if="!active">
                                                    {{item.name}}
                                                </span>
                                                    <span style="font-size: 12px;color: #364eff;font-weight: bold"
                                                          v-else>
                                                    {{item.name}}
                                                </span>
                                                </div>
                                                <div v-else style="cursor: pointer" @click="ShowDetail(item)">
                                                <span style="color:black;" v-if="!active">
                                                    {{item.name}}
                                                </span>
                                                    <span style="color: #364eff;font-weight: bold" v-else>
                                                    {{item.name}}
                                                </span>
                                                </div>
                                            </template>
                                            <template v-slot:append="{ item }">
                                                <div>
                                                    <v-btn text icon color="green lighten-2"
                                                           @click="EditCompetency(item)">
                                                        <v-icon>mdi-pencil-circle</v-icon>
                                                    </v-btn>
                                                    <v-btn text icon color="red lighten-2" @click="DelCompetency(item)">
                                                        <v-icon>mdi-close-circle</v-icon>
                                                    </v-btn>
                                                </div>

                                            </template>
                                        </v-treeview>
                                    </v-card>
                                </v-container>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-subheader>
                                    <span style="color: black">สร้างข้อมูล Competency</span>
                                </v-subheader>
                                <v-list-item>
                                    <v-card style="width: 100%">
                                        <v-tabs
                                                v-model="tab"
                                                dark
                                                background-color="teal darken-3"
                                                show-arrows
                                        >
                                            <v-tab
                                                    key="CompetencyManage"
                                            >
                                                ตั้งค่า CoreCompetency
                                            </v-tab>
                                            <!--                                        <v-tab-->
                                            <!--                                                key="CompetencyView"-->
                                            <!--                                        >-->
                                            <!--                                            แสดงข้อมูล Competency-->
                                            <!--                                        </v-tab>-->
                                        </v-tabs>

                                        <v-tabs-items v-model="tab">
                                            <v-tab-item
                                                    key="CompetencyManage"
                                            >
                                                <v-container>
                                                    <v-list-item>
                                                        <v-autocomplete outlined :items="itemsSel" item-text="name"
                                                                        item-value="DelvNo" label="กลุ่ม"
                                                                        v-model="SelDelvNo" @change="ChooseCompetency">
                                                            <template v-slot:item="{item}">
                                                                <div style="font-weight: bold;color: red"
                                                                     v-if="item.DelvLevel == '0'">
                                                                    <v-chip color="red" dark>
                                                                        <v-icon>
                                                                            mdi-chevron-right
                                                                        </v-icon>
                                                                    </v-chip>
                                                                    <span>
                                                {{item.name}}
                                            </span>
                                                                </div>
                                                                <div style="font-weight: bold;color: darkgreen;margin-left: 10px"
                                                                     v-else-if="item.DelvLevel == '1'">
                                                                    <v-chip color="#2E7D32" dark>
                                                                        <v-icon>
                                                                            mdi-chevron-double-right
                                                                        </v-icon>
                                                                    </v-chip>
                                                                    <span>
                                                {{item.name}}
                                            </span>
                                                                </div>
                                                                <div style="font-weight: bold;color: #42b983;margin-left: 20px"
                                                                     v-else>
                                                                    <v-chip color="#81C784" dark>
                                                                        <v-icon>
                                                                            mdi-chevron-triple-right
                                                                        </v-icon>
                                                                    </v-chip>
                                                                    <span>
                                                {{item.name}}
                                            </span>
                                                                </div>
                                                            </template>
                                                            <template v-slot:selection="{item}">
                                                                <div style="font-weight: bold;color: red"
                                                                     v-if="item.DelvLevel == '0'">
                                                                    <v-chip color="red" dark>
                                                                        <v-icon>
                                                                            mdi-chevron-right
                                                                        </v-icon>
                                                                    </v-chip>
                                                                    <span>
                                                {{item.name}}
                                            </span>
                                                                </div>
                                                                <div style="font-weight: bold;color: darkgreen;margin-left: 10px"
                                                                     v-else-if="item.DelvLevel == '1'">
                                                                    <v-chip color="#2E7D32" dark>
                                                                        <v-icon>
                                                                            mdi-chevron-double-right
                                                                        </v-icon>
                                                                    </v-chip>
                                                                    <span>
                                                {{item.name}}
                                            </span>
                                                                </div>
                                                                <div style="font-weight: bold;color: #42b983;margin-left: 20px"
                                                                     v-else>
                                                                    <v-chip color="#81C784" dark>
                                                                        <v-icon>
                                                                            mdi-chevron-triple-right
                                                                        </v-icon>
                                                                    </v-chip>
                                                                    <span>
                                                {{item.name}}
                                            </span>
                                                                </div>
                                                            </template>
                                                        </v-autocomplete>
                                                    </v-list-item>
                                                    <v-list-item>
                                                        <v-row class="d-flex justify-center">
                                                            <v-col
                                                                    cols="12"
                                                                    md="6">
                                                                <v-autocomplete
                                                                        :items="DepartData"
                                                                        item-text="dep_name"
                                                                        item-value="dep_id"
                                                                        outlined
                                                                        v-model="departSel"
                                                                        label="หน่วยงาน"
                                                                >
                                                                    <template v-slot:item="{item}">
                                                                    <span style="font-weight: bold;color: darkslateblue">
                                                                        {{item.dep_name}}
                                                                    </span>
                                                                    </template>
                                                                    <template v-slot:selection="{item}">
                                                                    <span style="font-weight: bold;color: #42b983">
                                                                        {{item.dep_name}}
                                                                    </span>
                                                                    </template>
                                                                </v-autocomplete>
                                                            </v-col>
                                                        </v-row>
                                                    </v-list-item>
                                                    <v-list-item>
                                                        <v-row>
                                                            <v-col
                                                                    md="6"
                                                                    cols="12">
                                                                <v-text-field
                                                                        v-model="DelvDes"
                                                                        label="ชื่อ Competency"
                                                                        outlined
                                                                >
                                                                </v-text-field>
                                                            </v-col>
                                                            <v-col
                                                                    md="6"
                                                                    cols="12">
                                                                <v-text-field
                                                                        v-model="DelvEng"
                                                                        label="ชื่อ(Eng) Competency"
                                                                        outlined
                                                                >
                                                                </v-text-field>
                                                            </v-col>
                                                        </v-row>
                                                    </v-list-item>
                                                    <v-list-item>
                                                        <v-row class="d-flex justify-center">
                                                            <v-col
                                                                    cols="12"
                                                                    md="6">
                                                                <v-text-field
                                                                        v-model="DelvShort"
                                                                        label="ชื่อย่อ Competency"
                                                                        outlined
                                                                >
                                                                </v-text-field>
                                                            </v-col>
                                                            <v-col
                                                                    cols="12"
                                                                    md="6">
                                                                <v-text-field
                                                                        v-model="PSU"
                                                                        label="PSU"
                                                                        outlined
                                                                >
                                                                </v-text-field>
                                                            </v-col>
                                                        </v-row>
                                                    </v-list-item>
                                                    <v-list-item>
                                                        <v-row class="d-flex justify-center">
                                                            <v-col
                                                                    md="8"
                                                                    cols="12">
                                                                <v-textarea
                                                                        v-model="DelvRm"
                                                                        label="คำอธิบาย"
                                                                        outlined
                                                                >
                                                                </v-textarea>
                                                            </v-col>
                                                        </v-row>
                                                    </v-list-item>
                                                </v-container>
                                            </v-tab-item>
                                            <v-tab-item
                                                    key="CompetencyView"
                                            >
                                                <v-container>
                                                    <v-data-table
                                                            :headers="headerCoreCompetency"
                                                            :items="CoreCompetencyData"
                                                            item-key="name"
                                                            show-expand
                                                            class="elevation-1"
                                                    >
                                                        <template v-slot:item.action>
                                                            <v-btn outlined color="#E91E63">ลบ</v-btn>
                                                        </template>
                                                        <template v-slot:expanded-item="{ headers, item }">
                                                            <td :colspan="headers.length">รายละเอียด : {{ item.name }}
                                                            </td>
                                                        </template>
                                                    </v-data-table>
                                                </v-container>
                                            </v-tab-item>
                                        </v-tabs-items>
                                    </v-card>
                                </v-list-item>
                                <div align="center" style="margin-top: 15px">
                                    <v-btn
                                            color="primary"
                                            outlined
                                            @click="insertCoreCompetency"
                                    >
                                        เพิ่มข้อมูล
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-container>
            </v-content>
            <template>
                <v-dialog
                        v-model="dialogDetail"
                        max-width="800"
                >
                    <v-card v-if="itemToShow != null">
                        <v-card-title class="headline"><span style="color: #42b983;font-weight: bold">{{itemToShow.DelvDes}}</span>
                        </v-card-title>

                        <v-card-text>
                            <v-row>
                                <v-col
                                        cols="12"
                                        md="12">
                                    <v-divider></v-divider>
                                    <p style="font-weight: bold;color: black">
                                        <span style="color: #364eff">ชื่อย่อ:</span> {{itemToShow.DelvShort}}
                                    </p>
                                    <v-divider></v-divider>
                                    <p style="font-weight: bold;color: black">
                                        <span style="color: #364eff">ชื่อ Eng:</span> {{itemToShow.DelvEng}}
                                    </p>
                                    <v-divider></v-divider>
                                    <p style="font-weight: bold;color: black">
                                        <span style="color: #364eff">คำอธิบาย:</span> {{itemToShow.DelvRm}}
                                    </p>
                                    <v-divider></v-divider>
                                    <p style="font-weight: bold;color: black">
                                        <span style="color: #364eff">PSU:</span> {{itemToShow.PSU}}
                                    </p>
                                    <v-divider></v-divider>
                                    <p style="font-weight: bold;color: black" v-if="itemToShow.DelvGroup == 'A'">
                                        <span style="color: #364eff">กรุ๊ป:</span> สมรรถนะหลัก
                                    </p>
                                    <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'B'">
                                        <span style="color: #364eff">กรุ๊ป:</span> สมรรถนะด้านบริหาร
                                    </p>
                                    <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'C'">
                                        <span style="color: #364eff">กรุ๊ป:</span> จิตสํานึกด้านความเสียงและความปลอดภัย
                                    </p>
                                    <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'D'">
                                        <span style="color: #364eff">กรุ๊ป:</span> กลยุทธ์
                                    </p>
                                    <v-divider></v-divider>
                                    <p style="font-weight: bold;color: black">
                                        <span style="color: #364eff">คณะ/หน่วยงาน:</span> {{itemToShow.dep_name}}
                                    </p>
                                    <v-divider></v-divider>
                                </v-col>
                            </v-row>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                    color="green darken-1"
                                    text
                                    @click="dialogDetail = false"
                            >
                                ปิด
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>
            <template>
                <v-dialog
                        v-model="dialogEdit"
                        persistent
                        max-width="800"
                >
                    <v-card v-if="itemToShow != null">
                        <v-card-title class="headline"><span style="color: #42b983;font-weight: bold">{{itemToShow.DelvDes}}</span>
                        </v-card-title>

                        <v-card-text>
                            <v-row>
                                <v-col
                                        cols="12"
                                        md="12">
                                    <v-divider></v-divider>
                                    <span style="color: #364eff">กลุ่ม:</span>
                                    <v-autocomplete outlined :items="itemsSel" item-value="id" item-text="name"
                                                    v-model="SelDelvNoEdit" disabled>
                                        <template v-slot:item="{item}">
                                            <div style="font-weight: bold;color: red" v-if="item.DelvLevel == '0'">
                                                <v-chip color="red" dark>
                                                    <v-icon>
                                                        mdi-chevron-right
                                                    </v-icon>
                                                </v-chip>
                                                <span>
                                                {{item.name}}
                                            </span>
                                            </div>
                                            <div style="font-weight: bold;color: darkgreen;margin-left: 10px"
                                                 v-else-if="item.DelvLevel == '1'">
                                                <v-chip color="#2E7D32" dark>
                                                    <v-icon>
                                                        mdi-chevron-double-right
                                                    </v-icon>
                                                </v-chip>
                                                <span>
                                                {{item.name}}
                                            </span>
                                            </div>
                                            <div style="font-weight: bold;color: #42b983;margin-left: 20px" v-else>
                                                <v-chip color="#81C784" dark>
                                                    <v-icon>
                                                        mdi-chevron-triple-right
                                                    </v-icon>
                                                </v-chip>
                                                <span>
                                                {{item.name}}
                                            </span>
                                            </div>
                                        </template>
                                        <template v-slot:selection="{item}">
                                            <div style="font-weight: bold;color: red" v-if="item.DelvLevel == '0'">
                                                <v-chip color="red" dark>
                                                    <v-icon>
                                                        mdi-chevron-right
                                                    </v-icon>
                                                </v-chip>
                                                <span>
                                                {{item.name}}
                                            </span>
                                            </div>
                                            <div style="font-weight: bold;color: darkgreen;margin-left: 10px"
                                                 v-else-if="item.DelvLevel == '1'">
                                                <v-chip color="#2E7D32" dark>
                                                    <v-icon>
                                                        mdi-chevron-double-right
                                                    </v-icon>
                                                </v-chip>
                                                <span>
                                                {{item.name}}
                                            </span>
                                            </div>
                                            <div style="font-weight: bold;color: #42b983;margin-left: 20px" v-else>
                                                <v-chip color="#81C784" dark>
                                                    <v-icon>
                                                        mdi-chevron-triple-right
                                                    </v-icon>
                                                </v-chip>
                                                <span>
                                                {{item.name}}
                                            </span>
                                            </div>
                                        </template>
                                    </v-autocomplete>
                                    <v-divider></v-divider>
                                    <p style="font-weight: bold;color: black">
                                        <span style="color: #364eff">ชื่อเต็ม:</span>
                                        <v-text-field outlined v-model="DelvDesEdit"></v-text-field>
                                    </p>
                                    <v-divider></v-divider>
                                    <p style="font-weight: bold;color: black">
                                        <span style="color: #364eff">ชื่อย่อ:</span>
                                        <v-text-field outlined v-model="DelvShortEdit"></v-text-field>
                                    </p>
                                    <v-divider></v-divider>
                                    <p style="font-weight: bold;color: black">
                                        <span style="color: #364eff">ชื่อ Eng:</span>
                                        <v-text-field outlined v-model="DelvEngEdit"></v-text-field>
                                    </p>
                                    <v-divider></v-divider>
                                    <p style="font-weight: bold;color: black">
                                        <span style="color: #364eff">คำอธิบาย:</span>
                                        <v-textarea outlined v-model="DelvRmEdit"></v-textarea>
                                    </p>
                                    <v-divider></v-divider>
                                    <p style="font-weight: bold;color: black">
                                        <span style="color: #364eff">PSU:</span>
                                        <v-text-field outlined v-model="PSUEdit"></v-text-field>
                                    </p>
                                    <v-divider></v-divider>
                                    <p style="font-weight: bold;color: black" v-if="itemToShow.DelvGroup == 'A'">
                                        <span style="color: #364eff">กรุ๊ป:</span> สมรรถนะหลัก
                                    </p>
                                    <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'B'">
                                        <span style="color: #364eff">กรุ๊ป:</span> สมรรถนะด้านบริหาร
                                    </p>
                                    <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'C'">
                                        <span style="color: #364eff">กรุ๊ป:</span> จิตสํานึกด้านความเสียงและความปลอดภัย
                                    </p>
                                    <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'D'">
                                        <span style="color: #364eff">กรุ๊ป:</span> กลยุทธ์
                                    </p>
                                    <v-divider></v-divider>
                                    <p style="font-weight: bold;color: black">
                                        <span style="color: #364eff">คณะ/หน่วยงาน:</span>
                                        <v-autocomplete
                                                :items="DepartData"
                                                item-text="dep_name"
                                                item-value="dep_id"
                                                outlined
                                                v-model="departSelEdit"
                                                label="หน่วยงาน"
                                        >
                                            <template v-slot:item="{item}">
                                                                    <span style="font-weight: bold;color: darkslateblue">
                                                                        {{item.dep_name}}
                                                                    </span>
                                            </template>
                                            <template v-slot:selection="{item}">
                                                                    <span style="font-weight: bold;color: #42b983">
                                                                        {{item.dep_name}}
                                                                    </span>
                                            </template>
                                        </v-autocomplete>
                                    </p>
                                    <v-divider></v-divider>
                                </v-col>
                            </v-row>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                    color="yellow darken-2"
                                    text
                                    @click="EditCompetencyToDb"
                                    style="font-weight: bold;font-size: 18px"
                            >
                                แก้ไข
                            </v-btn>
                            <v-btn
                                    color="green darken-1"
                                    text
                                    @click="CloseDialogEdit"
                            >
                              ปิด
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>
            <template>
                <v-dialog
                        v-model="dialogDel"
                        persistent
                        max-width="500"
                >
                    <v-card v-if="DelvDesDel != ''">
                        <v-card-title class="headline"><span
                                style="color: #42b983;font-weight: bold">{{DelvDesDel}}</span></v-card-title>

                        <v-card-text>
                        <span>
                            ต้องการลบข้อมูล Competency : {{DelvDesDel}} ใช่หรือไม่ ??
                        </span>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                    color="blue darken-1"
                                    outlined
                                    @click="DelCompetencyToDb"
                            >
                                ใช่
                            </v-btn>
                            <v-btn
                                    color="green darken-1"
                                    text
                                    @click="dialogDel = false"
                            >
                              ปิด
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>
        </template>
        <template v-else></template>
      </template>
    </v-row>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    // import serviceProvider from "@/resource/service_provider";
    import axios from "axios";
    import ConstData from "@/const/Const";

    export default {
        name: "SettingCompetency",
        data() {
            return {
              pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
              maintain: false,
                CheckAdmin: false,
                DelvDesDel: '',
                DelvNoDel: '',
                dialogDel: false,
                dialogEdit: false,
                dialogDetail: false,
                departSel: '35000',
                itemToShow: null,
                itemToDb: [],
                search: null,
                items: [],
                itemsSel: [],
                SelDelvNo: '',
                DelvDes: '',
                DelvShort: '',
                DelvEng: '',
                DelvRm: '',
                PSU: '',
                SelDelvNoEdit: '',
                DelvDesEdit: '',
                DelvShortEdit: '',
                DelvEngEdit: '',
                DelvRmEdit: '',
                PSUEdit: '',
                departSelEdit: '',
                tab: null,
                tab2: null,
                isMobile: false,
                CoreCompetencyData: [],
                FuncCompetencyData: [],
                headerCoreCompetency: [
                    {
                        text: 'Core Competency Name',
                        value: 'name',
                    },
                    {
                        text: '',
                        value: 'action',
                    },
                ]
            }
        },
        beforeDestroy() {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', this.onResize, {passive: true})
            }
        },
        computed: {
            ...mapGetters({
                MeData: 'Staff/getMeData',
                levelData: 'Level/getLevel',
                DepartData: 'Depart/getDepart',
                PositionsData: 'Positions/getPosition',
                Course: 'Course/getCourse',
                Competency: 'Competency/getCompetency',
              AllDepPermission: 'Permission/getAllDepUserPermission',
              DepPermission: 'Permission/getDepUserPermission',
              PermissionAdmin: 'Permission/getPermission',
              Permission: 'Permission/getPermissionUser',
              Permission_Ms: 'Permission/getPermissionMs',
              Permission_Dep_User: 'Permission/getPermissionDepUser',
              Permission_Dep: 'Permission/getPermissionDep',
              Approve_Ms: 'Permission/getApproveMs',
              Approve: 'Permission/getApprove',
              MenuPermiss: 'Permission/getMenuPermiss',
              IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
              appColor: 'Page/getColor',
              appHeaderName: 'Page/getHeaderName',
            }),
        },
        methods: {
            ...mapActions({
                initMeData: 'Staff/initMeData',
                initlevelData: 'Level/initLevelData',
                initDepartData: 'Depart/initDepartData',
                initPositionData: 'Positions/initPositionData',
                initCourseData: 'Course/initCourseData',
                initCompetencyData: 'Competency/initCompetencyData',
              initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
              initPermissionDepUserData: 'Permission/initPermissionDepUserData',
              initPermissionUserData: 'Permission/initPermissionUserData',
              initPermissionMsData: 'Permission/initPermissionMsData',
              getPermissionUserData: 'Permission/getPermissionUserData',
              getPermissionDep: 'Permission/getPermissionDepData',
              initPermissionDepData: 'Permission/initPermissionDepData',
              getPermissionDepUserData: 'Permission/getPermissionDepUserData',
              initApproveMsData: 'Permission/initApproveMsData',
              initApproveData: 'Permission/initApproveData',
              getPermissionData: 'Permission/getPermissionData',
              initPermissionData: 'Permission/initPermissionData',
              getMenuPermissData: 'Permission/getMenuPermissData',
              getIgnoreMenuPermissData: 'Permission/getIgnoreMenuPermissData',
              changeColor: 'Page/changeColor',
              changeHeaderName: 'Page/changeHeaderName',
              changeTypeProject: 'Project/changeTypeProject',
            }),
            onResize() {
                this.isMobile = window.innerWidth < 600
            },
            init() {
                this.items = []
                this.itemsSel = []
                this.initCompetencyData().then(res => {
                    if (res) {
                        this.Competency.map(compe_i => {
                            if (compe_i.DelvCover == null || compe_i.DelvCover == '') {
                                if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                    this.items.push({
                                        ...compe_i,
                                        id: compe_i.DelvNo,
                                        name: compe_i.DelvDes,
                                        DelvLevel: '0',
                                        children: []
                                    })
                                } else {
                                    this.items.push({
                                        ...compe_i,
                                        id: compe_i.DelvNo,
                                        name: compe_i.DelvEng + '( ' + compe_i.DelvDes + ' )',
                                        DelvLevel: '0',
                                        children: []
                                    })
                                }
                            }
                        })
                        this.items.map((data_i, idx) => {
                            if (data_i.children.length == 0) {
                                this.Competency.map(compe_i => {
                                    if (data_i.DelvNo == compe_i.DelvCover) {
                                        if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                            this.items[idx].children.push({
                                                ...compe_i,
                                                id: compe_i.DelvNo,
                                                name: compe_i.DelvDes,
                                                DelvLevel: '1',
                                                children: []
                                            })
                                        } else {
                                            this.items[idx].children.push({
                                                ...compe_i,
                                                id: compe_i.DelvNo,
                                                name: compe_i.DelvEng + '( ' + compe_i.DelvDes + ' )',
                                                DelvLevel: '1',
                                                children: []
                                            })
                                        }
                                    }
                                })
                            }
                        })
                        // lv2
                        this.items.map(data_i => {
                            if (data_i.children.length > 0) {
                                data_i.children.map((child1_i, idx) => {
                                    if (child1_i.children.length == 0) {
                                        this.Competency.map(compe_i => {
                                            if (child1_i.DelvNo == compe_i.DelvCover) {
                                                if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                                    data_i.children[idx].children.push({
                                                        ...compe_i,
                                                        id: compe_i.DelvNo,
                                                        name: compe_i.DelvDes,
                                                        DelvLevel: '2',
                                                        children: []
                                                    })
                                                } else {
                                                    data_i.children[idx].children.push({
                                                        ...compe_i,
                                                        id: compe_i.DelvNo,
                                                        name: compe_i.DelvEng + '( ' + compe_i.DelvDes + ' )',
                                                        DelvLevel: '2',
                                                        children: []
                                                    })
                                                }

                                            }
                                        })
                                    }
                                })
                            }
                        })

                        // item to autocomplete
                        this.items.map(itemRoot => {
                            this.itemsSel.push({
                                ...itemRoot
                            })
                            if (itemRoot.children.length > 0) {
                                itemRoot.children.map(itemChild1 => {
                                    this.itemsSel.push({
                                        ...itemChild1
                                    })
                                    if (itemChild1.children.length > 0) {
                                        itemChild1.children.map(itemChild2 => {
                                            this.itemsSel.push({
                                                ...itemChild2
                                            })
                                        })
                                    }
                                })
                            }
                        })
                    }
                })
            },
            CloseDialogEdit() {
                this.dialogEdit = false
                this.SelDelvNoEdit = ''
                this.DelvDesEdit = ''
                this.DelvShortEdit = ''
                this.DelvEngEdit = ''
                this.DelvRmEdit = ''
                this.PSUEdit = ''
                this.departSelEdit = ''
            },
            EditCompetency(item) {
                var CheckEdit = false
              if (this.PermissionAdmin.length > 0) {
                this.PermissionAdmin.map((Per_i, idx) => {
                  if (Per_i.permission_id == '4001') {
                    CheckEdit = true

                    this.dialogEdit = true
                    this.itemToShow = null
                    this.itemToShow = item
                    this.SelDelvNoEdit = item.DelvNo
                    this.DelvDesEdit = item.DelvDes
                    this.DelvShortEdit = item.DelvShort
                    this.DelvEngEdit = item.DelvEng
                    this.DelvRmEdit = item.DelvRm
                    this.PSUEdit = item.PSU
                    if (item.dep_id == null && item.dep_id == '') {
                      this.departSelEdit = item.dep_id
                    } else {
                      this.departSelEdit = '35000'
                    }
                  } else {
                    if (!CheckEdit && idx == this.PermissionAdmin.length - 1) {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                      })
                    }
                  }
                })
              } else {
                this.Permission.map((Per_i, idx) => {
                  if (Per_i.permission_id == '4001') {
                    CheckEdit = true

                    this.dialogEdit = true
                    this.itemToShow = null
                    this.itemToShow = item
                    this.SelDelvNoEdit = item.DelvNo
                    this.DelvDesEdit = item.DelvDes
                    this.DelvShortEdit = item.DelvShort
                    this.DelvEngEdit = item.DelvEng
                    this.DelvRmEdit = item.DelvRm
                    this.PSUEdit = item.PSU
                    if (item.dep_id == null && item.dep_id == '') {
                      this.departSelEdit = item.dep_id
                    } else {
                      this.departSelEdit = '35000'
                    }
                  } else {
                    if (!CheckEdit && idx == this.Permission.length - 1) {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                      })
                    }
                  }
                })
              }

            },
            DelCompetency(item) {
                var DelCompe = false
              if (this.PermissionAdmin.length > 0) {
                this.PermissionAdmin.map((Per_i, idx) => {
                  if (Per_i.permission_id == '4001') {
                    DelCompe = true

                    this.DelvNoDel = item.DelvNo
                    this.DelvDesDel = item.DelvDes
                    this.dialogDel = true
                  } else {
                    if (!DelCompe && idx == this.PermissionAdmin.length - 1) {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                      })
                    }
                  }
                })
              } else {
                this.Permission.map((Per_i, idx) => {
                  if (Per_i.permission_id == '4001') {
                    DelCompe = true

                    this.DelvNoDel = item.DelvNo
                    this.DelvDesDel = item.DelvDes
                    this.dialogDel = true
                  } else {
                    if (!DelCompe && idx == this.Permission.length - 1) {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                      })
                    }
                  }
                })
              }

            },
            DelCompetencyToDb() {
                var headerAxios = {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-REST-METHOD': 'DELETE'
                    }
                }
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_perseondelv/DelvNo/' + this.DelvNoDel, '', headerAxios).then(res => { // บัยทึกช้อมูลลงตาราง
                    if (res.data.status) {
                        this.$swal.fire({
                            icon: 'success',
                            title: 'ลบข้อมูลสำเร็จ'
                        })
                        this.dialogDel = false
                        this.DelvNoDel = ''
                        this.DelvDesDel = ''
                        this.init()
                    }
                })
            },
            EditCompetencyToDb() {
              this.itemToDb = []
              var CheckEdit = false
              if (this.PermissionAdmin.length > 0) {
                this.PermissionAdmin.map((Per_i, idx) => {
                  if (Per_i.permission_id == '4001') {
                    CheckEdit = true
                    if (this.Competency.length > 0) {
                      this.itemToDb = this.Competency.filter(item => item.DelvNo == this.SelDelvNoEdit)[0]
                    }
                    var headerAxios = {
                      headers: {
                        'Content-Type': 'application/json',
                        'X-REST-METHOD': 'POST'
                      }
                    }
                    var param = {
                      DelvNo: this.itemToDb.DelvNo,
                      DelvDes: this.DelvDesEdit,
                      DelvShort: this.DelvShortEdit,
                      DelvGroup: this.itemToDb.DelvGroup,
                      DelvLevel: this.itemToDb.DelvLevel,
                      DelvEng: this.DelvEngEdit,
                      DelvCover: this.itemToDb.DelvCover,
                      DelvRm: this.DelvRmEdit,
                      Delvstatus: this.itemToDb.Delvstatus,
                      Ps_cancel: this.itemToDb.Ps_cancel,
                      Date_cancel: this.itemToDb.Date_cancel,
                      Entry_person: this.itemToDb.Entry_person,
                      Entry_date: this.itemToDb.Entry_date,
                      PSU: this.PSUEdit,
                      DepCode: this.departSelEdit
                    }
                    if (this.DelvDesEdit == '' || this.SelDelvNoEdit == '') {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'พบข้อผิดพลาด โปรดกรอกข้อมูลให้ครบถ้วน ชื่อเต็ม, กลุ่ม ต้องไม่เป็นค่าว่าง'
                      })
                    } else {

                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_perseondelv/DelvNo/' + this.itemToDb.DelvNo, param, headerAxios).then(res => { // บัยทึกช้อมูลลงตาราง
                        if (res.data.status) {
                          this.$swal.fire({
                            icon: 'success',
                            title: 'แก้ไขข้อมูลสำเร็จ'
                          })
                          this.init()
                          this.dialogEdit = false
                          this.SelDelvNoEdit = ''
                          this.DelvDesEdit = ''
                          this.DelvShortEdit = ''
                          this.DelvEngEdit = ''
                          this.DelvRmEdit = ''
                          this.PSUEdit = ''
                          this.departSelEdit = ''
                        }
                      })

                    }
                  } else {
                    if (!CheckEdit && idx == this.PermissionAdmin.length - 1) {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                      })
                    }
                  }
                })
              } else {
                this.Permission.map((Per_i, idx) => {
                  if (Per_i.permission_id == '4001') {
                    CheckEdit = true
                    if (this.Competency.length > 0) {
                      this.itemToDb = this.Competency.filter(item => item.DelvNo == this.SelDelvNoEdit)[0]
                    }
                    var headerAxios = {
                      headers: {
                        'Content-Type': 'application/json',
                        'X-REST-METHOD': 'POST'
                      }
                    }
                    var param = {
                      DelvNo: this.itemToDb.DelvNo,
                      DelvDes: this.DelvDesEdit,
                      DelvShort: this.DelvShortEdit,
                      DelvGroup: this.itemToDb.DelvGroup,
                      DelvLevel: this.itemToDb.DelvLevel,
                      DelvEng: this.DelvEngEdit,
                      DelvCover: this.itemToDb.DelvCover,
                      DelvRm: this.DelvRmEdit,
                      Delvstatus: this.itemToDb.Delvstatus,
                      Ps_cancel: this.itemToDb.Ps_cancel,
                      Date_cancel: this.itemToDb.Date_cancel,
                      Entry_person: this.itemToDb.Entry_person,
                      Entry_date: this.itemToDb.Entry_date,
                      PSU: this.PSUEdit,
                      DepCode: this.departSelEdit
                    }
                    if (this.DelvDesEdit == '' || this.SelDelvNoEdit == '') {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'พบข้อผิดพลาด โปรดกรอกข้อมูลให้ครบถ้วน ชื่อเต็ม, กลุ่ม ต้องไม่เป็นค่าว่าง'
                      })
                    } else {

                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_perseondelv/DelvNo/' + this.itemToDb.DelvNo, param, headerAxios).then(res => { // บัยทึกช้อมูลลงตาราง
                        if (res.data.status) {
                          this.$swal.fire({
                            icon: 'success',
                            title: 'แก้ไขข้อมูลสำเร็จ'
                          })
                          this.init()
                          this.dialogEdit = false
                          this.SelDelvNoEdit = ''
                          this.DelvDesEdit = ''
                          this.DelvShortEdit = ''
                          this.DelvEngEdit = ''
                          this.DelvRmEdit = ''
                          this.PSUEdit = ''
                          this.departSelEdit = ''
                        }
                      })

                    }
                  } else {
                    if (!CheckEdit && idx == this.Permission.length - 1) {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                      })
                    }
                  }
                })
              }
            },
            ChooseCompetency() {
                this.itemToDb = []
                if (this.items.length > 0) {
                    this.itemToDb = this.Competency.filter(item => item.DelvNo == this.SelDelvNo)[0]
                }
            },
            ShowDetail(item) {
                this.dialogDetail = true
                this.itemToShow = null
                this.itemToShow = item
            },
            insertCoreCompetency() {
                var CheckInsert = false
              if (this.PermissionAdmin.length > 0) {
                this.PermissionAdmin.map((Per_i, idx) => {
                  if (Per_i.permission_id == '4001') {
                    CheckInsert = true

                    var DelvNoCal = ''
                    var headerAxios = {
                      headers: {
                        'Content-Type': 'application/json'
                      }
                    }
                    var param = {
                      DelvNo: '',
                      DelvDes: this.DelvDes,
                      DelvShort: this.DelvShort,
                      DelvGroup: '',
                      DelvLevel: '',
                      DelvEng: this.DelvEng,
                      DelvCover: '',
                      DelvRm: this.DelvRm,
                      Delvstatus: '1',
                      Ps_cancel: '',
                      Date_cancel: '',
                      Entry_person: '',
                      Entry_date: '',
                      PSU: this.PSU,
                      DepCode: this.departSel
                    }
                    if (this.DelvDes == '' || this.SelDelvNo == '') {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'พบข้อผิดพลาด โปรดกรอกข้อมูลให้ครบถ้วน ชื่อ Competency, กลุ่ม ต้องไม่เป็นค่าว่าง'
                      })
                    } else {
                      if (this.itemToDb.DelvCover == null || this.itemToDb.DelvCover == '') {
                        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_perseondelv/DelvCover/' + this.itemToDb.DelvNo + '/?sort=DelvNo_DESC&limit=1', headerAxios).then(res => { // บัยทึกช้อมูลลงตาราง
                          if (res.data) {
                            switch (('' + (parseInt(res.data.DelvNo.substring(1, res.data.DelvNo.split('-')[0].length)) + 1)).length) {
                              case 1:
                                DelvNoCal = '00' + (parseInt(res.data.DelvNo.substring(1, res.data.DelvNo.split('-')[0].length)) + 1)
                                break
                              case 2:
                                DelvNoCal = '0' + (parseInt(res.data.DelvNo.substring(1, res.data.DelvNo.split('-')[0].length)) + 1)
                                break
                              default:
                                DelvNoCal = (parseInt(res.data.DelvNo.substring(1, res.data.DelvNo.split('-')[0].length)) + 1)
                                break
                            }
                            param.DelvNo = res.data.DelvNo.substring(0, 1) + DelvNoCal + '-000'
                            param.DelvLevel = '1'
                            param.DelvCover = res.data.DelvCover
                            param.DelvGroup = res.data.DelvGroup

                            headerAxios = {
                              headers: {
                                'Content-Type': 'application/json',
                                'X-REST-METHOD': 'PUT'
                              }
                            }

                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_perseondelv', param, headerAxios).then(res => { // บัยทึกช้อมูลลงตาราง
                              if (res.data.status) {
                                this.$swal.fire({
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลสำเร็จ'
                                })
                                this.init()
                                this.DelvDes = ''
                                this.DelvShort = ''
                                this.DelvEng = ''
                                this.DelvRm = ''
                                this.PSU = ''
                              }
                            })

                          } else {
                            DelvNoCal = ''
                            this.DelvDes = ''
                            this.DelvShort = ''
                            this.DelvEng = ''
                            this.DelvRm = ''
                            this.PSU = ''
                          }
                        })
                      } else {
                        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_perseondelv/DelvCover/' + this.itemToDb.DelvNo + '/?sort=DelvNo_DESC&limit=1', param, headerAxios).then(res => { // บัยทึกช้อมูลลงตาราง
                          if (res.data) {
                            switch (('' + (parseInt(res.data.DelvNo.split('-')[1]) + 1)).length) {
                              case 1:
                                DelvNoCal = '00' + ((parseInt(res.data.DelvNo.split('-')[1]) + 1))
                                break
                              case 2:
                                DelvNoCal = '0' + ((parseInt(res.data.DelvNo.split('-')[1]) + 1))
                                break
                              default:
                                DelvNoCal = ((parseInt(res.data.DelvNo.split('-')[1]) + 1))
                                break
                            }

                            param.DelvNo = res.data.DelvNo.split('-')[0] + '-' + DelvNoCal
                            param.DelvLevel = '2'
                            param.DelvCover = res.data.DelvCover
                            param.DelvGroup = res.data.DelvGroup

                            headerAxios = {
                              headers: {
                                'Content-Type': 'application/json',
                                'X-REST-METHOD': 'PUT'
                              }
                            }

                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_perseondelv', param, headerAxios).then(res => { // บัยทึกช้อมูลลงตาราง
                              if (res.data.status) {
                                this.$swal.fire({
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลสำเร็จ'
                                })
                                this.init()
                                this.DelvDes = ''
                                this.DelvShort = ''
                                this.DelvEng = ''
                                this.DelvRm = ''
                                this.PSU = ''
                              }
                            })
                          } else {
                            switch (('' + (parseInt(this.itemToDb.DelvNo.split('-')[1]) + 1)).length) {
                              case 1:
                                DelvNoCal = '00' + ((parseInt(this.itemToDb.DelvNo.split('-')[1]) + 1))
                                break
                              case 2:
                                DelvNoCal = '0' + ((parseInt(this.itemToDb.DelvNo.split('-')[1]) + 1))
                                break
                              default:
                                DelvNoCal = ((parseInt(this.itemToDb.DelvNo.split('-')[1]) + 1))
                                break
                            }

                            param.DelvNo = this.itemToDb.DelvNo.split('-')[0] + '-' + DelvNoCal
                            param.DelvLevel = '2'
                            param.DelvCover = this.itemToDb.DelvNo
                            param.DelvGroup = this.itemToDb.DelvGroup

                            headerAxios = {
                              headers: {
                                'Content-Type': 'application/json',
                                'X-REST-METHOD': 'PUT'
                              }
                            }

                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_perseondelv', param, headerAxios).then(res => { // บัยทึกช้อมูลลงตาราง
                              if (res.data.status) {
                                this.$swal.fire({
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลสำเร็จ'
                                })
                                this.init()
                                DelvNoCal = ''
                                this.DelvDes = ''
                                this.DelvShort = ''
                                this.DelvEng = ''
                                this.DelvRm = ''
                                this.PSU = ''
                              }
                            })
                          }
                        })
                      }
                    }
                  } else {
                    if (!CheckInsert && idx == this.PermissionAdmin.length - 1) {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                      })
                    }
                  }
                })
              } else {
                this.Permission.map((Per_i, idx) => {
                  if (Per_i.permission_id == '4001') {
                    CheckInsert = true

                    var DelvNoCal = ''
                    var headerAxios = {
                      headers: {
                        'Content-Type': 'application/json'
                      }
                    }
                    var param = {
                      DelvNo: '',
                      DelvDes: this.DelvDes,
                      DelvShort: this.DelvShort,
                      DelvGroup: '',
                      DelvLevel: '',
                      DelvEng: this.DelvEng,
                      DelvCover: '',
                      DelvRm: this.DelvRm,
                      Delvstatus: '1',
                      Ps_cancel: '',
                      Date_cancel: '',
                      Entry_person: '',
                      Entry_date: '',
                      PSU: this.PSU,
                      DepCode: this.departSel
                    }
                    if (this.DelvDes == '' || this.SelDelvNo == '') {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'พบข้อผิดพลาด โปรดกรอกข้อมูลให้ครบถ้วน ชื่อ Competency, กลุ่ม ต้องไม่เป็นค่าว่าง'
                      })
                    } else {
                      if (this.itemToDb.DelvCover == null || this.itemToDb.DelvCover == '') {
                        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_perseondelv/DelvCover/' + this.itemToDb.DelvNo + '/?sort=DelvNo_DESC&limit=1', headerAxios).then(res => { // บัยทึกช้อมูลลงตาราง
                          if (res.data) {
                            switch (('' + (parseInt(res.data.DelvNo.substring(1, res.data.DelvNo.split('-')[0].length)) + 1)).length) {
                              case 1:
                                DelvNoCal = '00' + (parseInt(res.data.DelvNo.substring(1, res.data.DelvNo.split('-')[0].length)) + 1)
                                break
                              case 2:
                                DelvNoCal = '0' + (parseInt(res.data.DelvNo.substring(1, res.data.DelvNo.split('-')[0].length)) + 1)
                                break
                              default:
                                DelvNoCal = (parseInt(res.data.DelvNo.substring(1, res.data.DelvNo.split('-')[0].length)) + 1)
                                break
                            }
                            param.DelvNo = res.data.DelvNo.substring(0, 1) + DelvNoCal + '-000'
                            param.DelvLevel = '1'
                            param.DelvCover = res.data.DelvCover
                            param.DelvGroup = res.data.DelvGroup

                            headerAxios = {
                              headers: {
                                'Content-Type': 'application/json',
                                'X-REST-METHOD': 'PUT'
                              }
                            }

                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_perseondelv', param, headerAxios).then(res => { // บัยทึกช้อมูลลงตาราง
                              if (res.data.status) {
                                this.$swal.fire({
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลสำเร็จ'
                                })
                                this.init()
                                this.DelvDes = ''
                                this.DelvShort = ''
                                this.DelvEng = ''
                                this.DelvRm = ''
                                this.PSU = ''
                              }
                            })

                          } else {
                            DelvNoCal = ''
                            this.DelvDes = ''
                            this.DelvShort = ''
                            this.DelvEng = ''
                            this.DelvRm = ''
                            this.PSU = ''
                          }
                        })
                      } else {
                        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_perseondelv/DelvCover/' + this.itemToDb.DelvNo + '/?sort=DelvNo_DESC&limit=1', param, headerAxios).then(res => { // บัยทึกช้อมูลลงตาราง
                          if (res.data) {
                            switch (('' + (parseInt(res.data.DelvNo.split('-')[1]) + 1)).length) {
                              case 1:
                                DelvNoCal = '00' + ((parseInt(res.data.DelvNo.split('-')[1]) + 1))
                                break
                              case 2:
                                DelvNoCal = '0' + ((parseInt(res.data.DelvNo.split('-')[1]) + 1))
                                break
                              default:
                                DelvNoCal = ((parseInt(res.data.DelvNo.split('-')[1]) + 1))
                                break
                            }

                            param.DelvNo = res.data.DelvNo.split('-')[0] + '-' + DelvNoCal
                            param.DelvLevel = '2'
                            param.DelvCover = res.data.DelvCover
                            param.DelvGroup = res.data.DelvGroup

                            headerAxios = {
                              headers: {
                                'Content-Type': 'application/json',
                                'X-REST-METHOD': 'PUT'
                              }
                            }

                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_perseondelv', param, headerAxios).then(res => { // บัยทึกช้อมูลลงตาราง
                              if (res.data.status) {
                                this.$swal.fire({
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลสำเร็จ'
                                })
                                this.init()
                                this.DelvDes = ''
                                this.DelvShort = ''
                                this.DelvEng = ''
                                this.DelvRm = ''
                                this.PSU = ''
                              }
                            })
                          } else {
                            switch (('' + (parseInt(this.itemToDb.DelvNo.split('-')[1]) + 1)).length) {
                              case 1:
                                DelvNoCal = '00' + ((parseInt(this.itemToDb.DelvNo.split('-')[1]) + 1))
                                break
                              case 2:
                                DelvNoCal = '0' + ((parseInt(this.itemToDb.DelvNo.split('-')[1]) + 1))
                                break
                              default:
                                DelvNoCal = ((parseInt(this.itemToDb.DelvNo.split('-')[1]) + 1))
                                break
                            }

                            param.DelvNo = this.itemToDb.DelvNo.split('-')[0] + '-' + DelvNoCal
                            param.DelvLevel = '2'
                            param.DelvCover = this.itemToDb.DelvNo
                            param.DelvGroup = this.itemToDb.DelvGroup

                            headerAxios = {
                              headers: {
                                'Content-Type': 'application/json',
                                'X-REST-METHOD': 'PUT'
                              }
                            }

                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_perseondelv', param, headerAxios).then(res => { // บัยทึกช้อมูลลงตาราง
                              if (res.data.status) {
                                this.$swal.fire({
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลสำเร็จ'
                                })
                                this.init()
                                DelvNoCal = ''
                                this.DelvDes = ''
                                this.DelvShort = ''
                                this.DelvEng = ''
                                this.DelvRm = ''
                                this.PSU = ''
                              }
                            })
                          }
                        })
                      }
                    }
                  } else {
                    if (!CheckInsert && idx == this.Permission.length - 1) {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                      })
                    }
                  }
                })
              }

            },
            insertFuncCompetency() {
                this.FuncCompetencyData.unshift({
                    id: this.CoreCompetencyData.length + 1,
                    name: this.FuncCompeModel,
                    detail: this.FuncDetailCompeModel
                })
                this.FuncCompeModel = ''
                this.FuncDetailCompeModel = ''
            },
        },
        mounted() {
          this.changeColor({
            color: ConstData.defaultColorApp
          })
          this.changeHeaderName({
            headerName: ConstData.defaultHeaderApp
          })
          this.changeTypeProject({
            type: null
          })
            this.initDepartData()
            this.onResize()
            window.addEventListener('resize', this.onResize, {passive: true})
            this.initMeData().then(async res => {
              if (res) {
                await this.getIgnoreMenuPermissData({
                  perid: this.MeData[0].perid,
                  page_id: '15'
                })

                this.getMenuPermissData().then(res => {
                  if (res) {
                    if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '15' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                      this.maintain = false
                      this.getPermissionData({
                        perid: this.MeData[0].perid
                      }).then(res => {
                        if (res) {
                          this.PermissionAdmin.map((Per_i, idx) => {
                            if (Per_i.permission_id == '4000') {
                              this.CheckAdmin = true

                              this.init()
                            } else {
                              if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                                this.$router.push('/')
                              }
                            }
                          })
                        } else {
                          // this.$router.push('/')
                          this.getPermissionUserData({
                            perid: this.MeData[0].perid
                          }).then(res => {
                            if (res) {
                              this.Permission.map((Per_i, idx) => {
                                if (Per_i.permission_id == '4000') {
                                  this.CheckAdmin = true

                                  this.init()
                                } else {
                                  if (!this.CheckAdmin && idx == this.Permission.length - 1) {
                                    this.$router.push('/')
                                  }
                                }
                              })
                            } else {
                              this.$router.push('/')
                            }
                          })
                        }
                      })
                    } else {
                      this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '15' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '15')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                      this.maintain = true
                    }
                  }
                }).then(err => {
                  if (err) {
                    this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '15' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '15')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                    this.maintain = true
                  }
                })
              }
            }).catch(reason => {
                console.log('Reject = ' + reason)
            })
        }
    }
</script>

<style scoped>
    .v-label {
        color: black;
    }

    .v-card {
        border: 1px solid;
    }

    .v-text-field >>> input {
        color: black;
    }

    .v-text-field >>> label {
        color: black;
        font-weight: bold;
    }

    .v-text-field >>> button {
        font-size: 0.1em;
    }
</style>
